import { Component } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { animRoutes } from './_animations/animations';

import { CurrentSlideService } from './_services/current-slide.service';
import { SectionsService } from './_services/sections.service';

import { Subject } from 'rxjs';
import { takeUntil} from 'rxjs/operators';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	animations: [animRoutes]
})
export class AppComponent {

	private unsubscribe$ = new Subject<void>();

	title = 'Bulova-Museum';
	isStory = false;
	navProgressLoaded = false;

	public activeSectionPosition;
	public sections;
	public sectionsPosFirst;
	public sectionsPosLast;


	constructor(private _router: Router, private _currentSlideService: CurrentSlideService, private _sectionsService: SectionsService) {

		_router.events
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe( (event: Event) => {
			if (event instanceof NavigationEnd) {
				// this.newRoute = this._router.url.replace('/', '');
				// let section = this.sections.find(data => data.routeName === this.newRoute);
				// this.setSectionPosition(section.position);
				
				let url = this._router.url.split('/');
				if(url[2] == 'story'){
					this.isStory = true;
				}
				else{
					this.isStory = false;
				}
			}
		});
	}

	ngOnInit() {
		this._router.navigate(['']);

		this.sections = this._sectionsService.getSections();
		this.sectionsPosFirst = this.sections[0].position;
		this.sectionsPosLast = this.sections[this.sections.length - 1].position;

		this.activeSectionPosition = this._sectionsService.getCurrentSectionPosition();
		this._sectionsService.changeSection
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe(position => {
			this.activeSectionPosition = position;
		});
	}

	
	getPosition(outlet) {
		return outlet.activatedRouteData['position'];
	}

	swipeUp(){
		if(!this.isStory){
			let goSection = this.activeSectionPosition + 1;
			let section = this.sections.find(data => data.position === goSection);
			if(goSection <= this.sectionsPosLast){	
				this._sectionsService.setCurrentPosition(goSection);
			}
		}

	}
	swipeDown(){
		if(!this.isStory){
			let goSection = this.activeSectionPosition - 1;
			let section = this.sections.find(data => data.position === goSection);
			if(goSection >= this.sectionsPosFirst){	
				this._sectionsService.setCurrentPosition(goSection);
			}
		}
	}

	animRouteStart(event: AnimationEvent) {
		this.navProgressLoaded = false;
	}
	animRouteDone(event: AnimationEvent) {
		this.navProgressLoaded = true;
	}

	
	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}
	
}

/*

see: https://medium.com/frontend-coach/angular-router-animations-what-they-dont-tell-you-3d2737a7f20b
for a better logic for animations
	*/
